<p-menubar [model]="items">
  <ng-template pTemplate="start">
    <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <img src="/assets/sw-logo-header-up.png" height="40" class="p-mr-2" />
    </a>
  </ng-template>
  <ng-template pTemplate="end">
    <label *ngIf="user"> {{ user?.nombre +' '+ user?.apellido }}</label>

    <button pButton type="button" (click)="logout()" label="Salir" icon="pi pi-power-off"
      class="p-button-link"></button>
  </ng-template>
</p-menubar>

<div class="p-4">
  <alert></alert>
  <p-toast></p-toast>
  <div class="container">
    <router-outlet></router-outlet>
  </div>
  <!--<app-messages></app-messages>-->
</div>
<!-- credits -->

<br />|
<br />
<div class="container">
  <div class="row">
    <div class="col-12 text-center">
      <p>
        <a href="" target="_top">Sherwin Williams de Centroamérica</a>
      </p>
    </div>
  </div>
</div>